export const SIGN_IN_URL = "https://users.spreadex.asia";
export const REGISTER_URL = "https://users.spreadex.asia/";
